import { emitters } from 'config';
import { MainContext } from 'context';
import { useContext } from 'react';
import { InfoListType } from 'types';
import { styled } from '../themes';

const Container = styled('div', {
  display: 'flex',
  alignItems: 'center',
  textAlign: 'left',

  ' @media (max-width: 768px)': {
    flexDirection: 'column',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
});

const List = styled('ul', {
  marginLeft: 0,
  listStyle: 'disc',
  padding: 0,
  marginBottom: 0,
  marginTop: 15,

  '@media (max-width: 768px)': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin: 10,
  },

  'li:first-child': {
    listStyle: 'none',
    marginLeft: 0,
    paddingRight: 6,
    '@media (max-width: 768px)': {
      listStyle: 'disc',
      marginLeft: 10,
      marginBottom: 5,
    },
  },
});

const ListItem = styled('li', {
  textAlign: 'left',
  float: 'left',
  marginX: 10,
  marginY: 0,
  paddingRight: 6,
  color: '$copyRightColor',
});

const Text = styled('p', {
  font: 'normal normal medium 12px/28px Montserrat',
  fontSize: 14,
  textAlign: 'left',
  letterSpacing: 0,
  color: '$copyRightColor',
  opacity: 1,
  marginY: 0,
});

const Link = styled('a', {
  fontFamily: 'inherit',
  fontSize: 'inherit',
  textDecoration: 'none',
  cursor: 'pointer',
  transition: 'color 0.3s ease',
  color: '$privacyColor',
  '&:hover': {
    outline: 0,
    color: '$privacyColor',
    textDecoration: 'none',
  },
});

function isTextLink(item: InfoListType) {
  return item.link ? (
    <Link href={item.link} target="_blank">
      {item.text}
    </Link>
  ) : (
    <Text>{item.text}</Text>
  );
}

function InfoList(): JSX.Element {
  const { state } = useContext(MainContext);
  return (
    <Container>
      <List>
        {emitters[state.emissor].infoList.map((item: InfoListType) => (
          <ListItem key={item.code}>{isTextLink(item)}</ListItem>
        ))}
      </List>
    </Container>
  );
}

export default InfoList;
